import { Dispatch} from "react";
import { IADPActions } from "../state/Actions";
import { IADPState, actions } from "../state";
import RequestService from "../../Services/Request.service";
import { VerifySetUpCodePayload, VerifySetUpCodeResponse } from "../types";
import { environment } from "../util/util";
import { useIPCBridge } from "./useIPCBridge";
const logPrefix = "[ADPClient][SetupCodeValidationServiceHook]"
export function useSetupCodeValidationService(dispatch:Dispatch<IADPActions>,appState: IADPState) {
  const {sendSetupCode} = useIPCBridge(dispatch,appState);
  const resetSchoolDetails = ()=>{
    console.log(logPrefix, "resetting school details...");
    dispatch(actions.createUpdateSchoolAction(undefined));
  }
  const cancelSetupCodeValidation = ()=>{
    console.log(logPrefix, "cancel setup code validation...");
    dispatch(actions.createUpdateSchoolAction(undefined));
    dispatch(actions.createSetAssessmentModeAction("notselected"));
    //reset validation metrics
  }
  const validateSetUpCode = (setupCode: string)=>{
   
    console.log(logPrefix,` validate setup code for ${appState.sessionState.selectedAssessmentMode} mode`);
    dispatch(actions.createValidationAction("setupCodeValidation"));//takes care of displaying spinner
    const payload: VerifySetUpCodePayload = {
      adpLaunchId: appState.appState.appLaunchId as string,
      setupCode:setupCode,
      requestDateTime: new Date().toISOString(),
      deviceId: appState.deviceState.deviceId as string,
    };
    
    const onlineServiceConfig = appState.appState.configuration?.onlineServices;
    const ncsServiceConfig = appState.connectedNCSState?.config.adsServices;
    let url = `${environment.resolveApiDomain()}/${onlineServiceConfig?.verifySetUpCode}?appName=adp&appVersion=${appState.appState.appVersion}`;
    if(ncsServiceConfig && appState.sessionState.selectedAssessmentMode === "ncs"){
      url = `${ncsServiceConfig?.verifySetUpCodeUrl}?appName=adp&appVersion=${appState.appState.appVersion}`
    };
    const onResponse = async (response: VerifySetUpCodeResponse) => {
      console.log(logPrefix,`setup code validation response status:`,response.status);
      dispatch(actions.createValidationAction(undefined));//remove spinner
      if (response.status === 200) {
          sendSetupCode(setupCode);
         console.table(response.status);
         dispatch(actions.createUpdateSchoolAction(response));
         if(!(response.assessmentLocations && response.assessmentLocations.length>0 && appState?.appState?.configuration?.enableLocation)){
          dispatch(actions.createSetViewAction("DeviceValidationView"));
         }
        }
      else if (response.errorCode){
        console.table(response.status);
        dispatch(actions.createUpdateSchoolAction({...response,setupCode:setupCode}));
       } 
        else {
          console.error(logPrefix,"Error validating setup code",response.status);
          dispatch(actions.createWarningAction("NoServerConnectionDetected"));
        }
    
      }
    RequestService.postSetupCode(payload, url, onResponse);
  }
 
  return {validateSetUpCode,resetSchoolDetails,cancelSetupCodeValidation}
}
